export enum OrderStatusEnum {
    ASerAcordado = 1,
    CustoExcedido = 2,
    EmRevisao = 3,
    Revisado = 4,
    Fraudulento = 5,
    AguardandoPagamento = 6,
    CustoPago = 7,
    RotaCriada = 8,
    EmFabricacao = 9,
    PedidoReagendado = 10,
    CriandoOrdemEnvio = 11,
    Pendente = 12,
    Regenerando = 13,
    AguardandoEtiqueta = 14,
    FaturaPendente = 15,
    AguardandoDevolucao = 16,
    DevolucaoConfirmada = 17,
    AgenciaIndisponivel = 18,
    EmManuseio = 19,
    ProntoParaImprimir = 20,
    EmitirNotaFiscal = 21,
    EtiquetaImpressa = 22,
    NaListaColeta = 23,
    ProntoParaCriacaoPKL = 24,
    ProntoParaColeta = 25,
    ProntoParaEntrega = 26,
    Coletado = 27,
    ProntoInativo = 28,
    EntregueNoMelipoint = 29,
    Atrasado = 30,
    ProntoParaEnvio = 31,
    SaiuParaEntrega = 32,
    AguardandoRetirada = 33,
    ContatoTransportadora = 34,
    DestinatarioAusente = 35,
    Reclamado = 36,
    Enviado = 37,
    Danificado = 38,
    EntregueComFeedback = 39,
    Entregue = 40,
    DevolvendoAoRemetente = 41,
    NaoEntregue = 42,
    Cancelado = 43,
    Recuperado = 44,
    EtiquetaExpirada = 45,
    NaoVerificado = 46,
    Fechado = 47,
    Erro = 48,
    Ativo = 49,
    NaoEspecificado = 50,
    ProntoInativoEnvio = 51,
    EnviadoInativo = 52,
    StatusDesconhecido = 53
}
